import Wizardable from 'components/widgets/Wizardable';
import WizardFooter from 'components/widgets/WizardFooter';
import flatten from 'lodash/flatten';
import PropTypes from 'prop-types';
import React from 'react';
import AddFutureItems from '../containers/AddFutureItems';
import { translationPrefix } from '../utils';
import SearchableMultiSelect from './SearchableMultiSelect';
import css from './SourceSelection.css';

class SourceSelection extends Wizardable {
    constructor(props) {
        super(props);
        this.selectAll = this.selectAll.bind(this);
        this.buttonOverrides = props.wizardOverrideButtons;
    }

    get flattenedUans() {
        const { uans } = this.props;
        let ret = uans;
        if (Array.isArray(ret)) {
            ret = flatten(uans);
        }
        return ret;
    }

    selectAll(value) {
        const { onAllChange, enableAddFuture } = this.props;
        onAllChange(
            this.flattenedUans.map(uanData => uanData.id),
            value
        );
        if (value) {
            enableAddFuture();
        }
    }

    validate() {
        const { translate } = this.props;
        const isValid = this.flattenedUans.filter(a => a.selected).length;

        const tooltipButtons = ['next'];
        this.setTooltip(
            tooltipButtons,
            isValid
                ? null
                : translate('STATIC.PAGES.TEAM_MEMBERS.SELECT_AT_LEAST_ONE_TOOLTIP', {
                      itemType: 'data source',
                  })
        );

        return isValid;
    }

    render() {
        const { onChange, lastAction, translate } = this.props;
        const selectedCount = this.flattenedUans.filter(uan => uan.selected).length;
        const totalCount = this.flattenedUans.length;
        const formattedUans = this.flattenedUans.map(uan => ({
            ...uan,
            ...(uan.icon && {
                Icon: 'img',
                iconProps: { src: uan.icon, alt: uan.name },
            }),
        }));

        return (
            <>
                <this.AnimationItem initialPose={lastAction} pose="visible" className={css.page}>
                    <div>
                        <div className={css.headline}>
                            <div className={css.preamble}>
                                <div>Select data sources to be available for this user</div>
                                <div className={css.faqLine}>
                                    For more information{' '}
                                    <a
                                        href="https://singular.zendesk.com/hc/en-us/articles/360020835952-Team-Management-FAQ"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        read the FAQ
                                    </a>
                                    .
                                </div>
                            </div>
                            <div className={css.selectorContainer}>
                                <div className={css.counter}>
                                    {translate(`${translationPrefix}.SELECTED_COUNT`, {
                                        selectedCount,
                                        totalCount,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <SearchableMultiSelect
                        className={css.multiSelectContainer}
                        allItems={formattedUans}
                        filteredItems={formattedUans}
                        onChange={onChange}
                        selectAll={this.selectAll}
                        searchPlaceholder={translate(`${translationPrefix}.PLACEHOLDER.SOURCE_SEARCH`)}
                    />
                </this.AnimationItem>
                <WizardFooter
                    buttons={this.getButtons()}
                    leftComponents={<AddFutureItems itemType="sources" form="base_source" dimensionFilter />}
                />
            </>
        );
    }
}

SourceSelection.propTypes = {
    wizardOverrideButtons: PropTypes.objectOf(PropTypes.any),
    translate: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onAllChange: PropTypes.func.isRequired,
    enableAddFuture: PropTypes.func.isRequired,
};

SourceSelection.defaultProps = {
    wizardOverrideButtons: {},
    translate: x => x,
};

export default SourceSelection;
